import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "maplibre-gl/dist/maplibre-gl.css";
import "./index.css";
import App from "./App.jsx";
import { LangProvider } from "./lib/i18n.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <LangProvider>
      {/* basename follows vite's --base so the app can live under a path
          prefix (EC2 serves it at /maps/; Bellatrix and dev at /).

          useTransitions={false} is a safety belt, not a preference (item 0124).
          By default react-router wraps EVERY location update in
          React.startTransition, which puts it on a transition lane. React
          renders higher-priority lanes first and transition lanes never expire
          into the queue while work of a higher priority keeps arriving — so a
          single component anywhere in the tree that re-renders itself in a
          loop (a setState in a useEffect whose deps change every render, which
          React does NOT warn about) starves navigation for as long as it runs.
          The symptom is silent and very confusing: history.pushState is
          synchronous so the URL changes, no error is thrown, and the outlet
          simply never swaps. That is exactly how the whole admin became
          single-tab on production.

          This app has no lazy routes and no data-router loaders, so a
          transition buys it nothing; making location updates ordinary state
          updates means they are batched with whatever else is pending instead
          of queued behind it. The loop that caused 0124 is fixed at source in
          RouteStylePicker.jsx — this is so that the next one is a slow tab,
          not an admin nobody can navigate. */}
      <BrowserRouter basename={import.meta.env.BASE_URL} useTransitions={false}>
        <App />
      </BrowserRouter>
    </LangProvider>
  </StrictMode>,
);
